import { TagPageSourceEnum } from "./utils/URL";

export interface PageConfig {
  path: string;
  pageId?: string;
  manualReportPV?: boolean;
  reportParams?: Function;
  gaParams?: {
    group1?: string;
    group2?: string;
  };
}

const routes: PageConfig[] = [
  {
    path: "/",
    pageId: "bookstore",
    reportParams: () => ({
      pdt: "store",
    }),
    gaParams: {
      group1: "index",
    },
  },
  {
    path: "/search",
    pageId: "search",
    manualReportPV: true,
    gaParams: {
      group1: "search",
    },
  },
  {
    path: "/search/[keyWord]",
    pageId: "search",
    manualReportPV: true,
    gaParams: {
      group1: "search",
    },
  },
  {
    path: "/tag",
    pageId: "tag",
    reportParams: (params: any) => ({
      pdt: "tag",
      pdid: params.tagId,
      param: {
        source: params.source || TagPageSourceEnum.homepage,
      },
    }),
    gaParams: {
      group1: "tag",
    },
  },
  {
    path: "/tag/[tagId]",
    pageId: "tag",
    reportParams: (params: any) => ({
      pdt: "tag",
      pdid: params.tagId,
      param: {
        source: params.source || TagPageSourceEnum.homepage,
      },
    }),
    gaParams: {
      group1: "tag",
    },
  },
  {
    path: "/book-list",
    pageId: "topic",
    reportParams: () => ({
      pdt: "topic",
    }),
  },
  {
    path: "/ranking",
    pageId: "ranking",
    reportParams: () => ({
      pdt: "rank",
    }),
    gaParams: {
      group1: "ranking",
    },
  },
  {
    path: "/chapterlist/[bookId]",
    pageId: "novellist",
    gaParams: {
      group1: "novellist",
    },
  },
  {
    path: "/manga-chapterlist",
    pageId: "mangalist",
    gaParams: {
      group1: "mangalist",
    },
  },
  {
    path: "/novel/[bookId]",
    pageId: "noveldetail",
  },
  {
    path: "/manga/[comicId]",
    pageId: "comicdetail",
  },
  {
    path: "/so",
    pageId: "seosearch",
  },
  {
    path: "/so/[cate]",
    pageId: "seosearch",
  },
];
export default routes;
